import { render, staticRenderFns } from "./PollOutput.vue?vue&type=template&id=456aba48"
import script from "./PollOutput.vue?vue&type=script&setup=true&lang=js"
export * from "./PollOutput.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports